/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [cover-upload-modal.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 11.02.20, 10:55
 */
import React, {useRef} from 'react';
import DialogBox from "../../dialogs/dialog-box";
import DropzoneUploader from '../../dropzone-uploader/dropzone-uploader';
import {useLanguage} from "../../configuration/configuration";
import {NONE_STATUS, notifyUploadChange, PENDING_STATUS, SUCCESS_STATUS} from "../../../actions";
import {useDispatch} from "react-redux";

/**
 * @param spacepath 'home' or 'generic/{spaceId}'
 * @param username
 * @param setIsOpen trigger for show/hide dialog
 * @param append - whether to reset current set of images or append to current list
 * @param source - one of COVER(default) or GALLERY
 */
const CoverUploadModal = ({spacepath, username, setIsOpen, append = false, source='COVER'}) => {
    const uploaderRef = useRef(null);
    const dispatch = useDispatch();
    const Lang = useLanguage();

    const onUpload = (event) => {
        dispatch(notifyUploadChange('UPLOAD', PENDING_STATUS, null));
        uploaderRef.current && uploaderRef.current.onUpload(event);
    };

    const onClose = event => {
        // dispatch(notifyUploadChange('UPLOAD', NONE_STATUS, null));
        setIsOpen(false);
    }

    // return <DialogBox wide isOpen={true} setIsOpen={() => setIsOpen(false)}
    return <DialogBox wide isOpen={true} setIsOpen={onClose}
                      title={Lang.dialog.uploadCover.title}
                      action={Lang.dialog.uploadCover.action}
                      callback={onUpload}>
        <DropzoneUploader
            spacepath={spacepath}
            append={append}
            username={username}
            source={source}
            onRef={(ref) => uploaderRef.current = ref}>
        </DropzoneUploader>

    </DialogBox>
}

export default CoverUploadModal;
